import React from 'react';
import PropTypes from 'prop-types';
import config from '../../../../../../../config';
import {getMemberRoleId} from '../../../../../../../utils/General';
import DropdownSelect from "../../../../../../../components-new/form/DropdownSelect";
import Translate from "../../../../../../../components/Translate";

const MemberRole = ({member, updateRole}) => {
    const options = config.roles
        .filter(role => role.id !== getMemberRoleId(member))
        .filter(o => o.id !== config.rolesMap.owner)

    const rolesToShow = options.map(r => {
        return {
            id: r.id,
            name: r.name,
            value: r.value,
            title: <Translate text={r.name}/>
        };
    });

    return (
        <DropdownSelect
            overlay
            options={rolesToShow}
            selectedValue={config.roles.find(role => role.id === getMemberRoleId(member))}
            onChange={(val) => updateRole(val.value)}
            variant='outline'
            renderLabel={
                (val) => <Translate text={val.name}/>
            }
            disableOption={option => option.value === config.rolesMap.owner}
            styles={{color: 'var(--ds-text-primary)'}}
        >
            {(option) => option.title}
        </DropdownSelect>
    );
}

MemberRole.propTypes = {
    member: PropTypes.object.isRequired,
    updateRole: PropTypes.func.isRequired,
};

export default MemberRole;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/EmployeesTable/partials/MemberRole.jsx